import { useState, useEffect } from 'react';
import log from 'chameleon/ui-stack/utilities/log';
import { QUESTION_TYPES } from 'chameleon-src/constants/assignment';
import {
  createQuizMutation,
  deleteQuizMutation,
} from 'chameleon-src/queries/mutations';

const initialState = {
  quizzes: {
    all: {
      id: null,
      isAssigned: false,
    },
    [QUESTION_TYPES.mcq]: {
      id: null,
      isAssigned: false,
    },
    [QUESTION_TYPES.frq]: {
      id: null,
      isAssigned: false,
    },
  },
  itemId: null,
};

const useQuizData = (
  items,
  client,
  itemTypeOption,
  subjectId,
  unitNumber,
  subunitNumber,
  educationPeriodCode,
  createCallback,
  deleteCallback,
) => {
  const [quizzes, setQuizzes] = useState(initialState.quizzes);
  const { id: itemId } = quizzes[itemTypeOption];

  useEffect(() => {
    setQuizzes(initialState.quizzes);
  }, [items]);

  const createQuiz = async (questions, title, type) => {
    let createdQuizId = quizzes?.[type]?.id;
    if (!createdQuizId) {
      let response;
      try {
        response = await client.mutate({
          mutation: createQuizMutation,
          variables: {
            libraryId: questions[0].libraryId,
            title,
            content: '{}',
            questionIds: questions
              .map(({ itemId: questionId }) => questionId)
              .join(','),
            autoCreateContent: true,
            subjectId: Number.parseInt(subjectId, 10),
            unitId: Number.parseInt(unitNumber, 10),
            subunitId: Number.parseInt(subunitNumber, 10),
            educationPeriod: Number.parseInt(educationPeriodCode, 10),
            quizType:
              type === 'all'
                ? type
                : type === QUESTION_TYPES.mcq
                  ? 'mcq'
                  : 'frq',
          },
        });
      } catch (error) {
        log('error', error);
      }

      if (response && response.data) {
        const {
          createQuiz: { itemId: quizId, ok },
        } = response.data;
        if (ok) {
          setQuizzes((state) => ({
            ...state,
            [type]: {
              id: quizId,
              isAssigned: false,
            },
          }));
          createdQuizId = quizId;
        }
      }
    }
    createCallback && createCallback(createdQuizId);
  };

  const deleteQuiz = async () => {
    if (itemId && !quizzes[itemTypeOption].isAssigned) {
      let response;
      try {
        response = await client.mutate({
          mutation: deleteQuizMutation,
          variables: {
            itemId,
          },
        });
      } catch (error) {
        log('error', error);
      }

      if (response && response.data) {
        const {
          deleteQuiz: { deleted },
        } = response.data;

        if (deleted) {
          setQuizzes((state) => ({
            ...state,
            [itemTypeOption]: {
              id: null,
              isAssigned: false,
            },
          }));
        }
      }
    }

    deleteCallback && deleteCallback();
  };

  const onAssignQuiz = () => {
    setQuizzes({
      ...quizzes,
      [itemTypeOption]: {
        ...quizzes[itemTypeOption],
        isAssigned: true,
      },
    });
  };

  return {
    itemId,
    quizzes,
    createQuiz,
    deleteQuiz,
    onAssignQuiz,
  };
};

export default useQuizData;
